import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NAV = [
    { path: '/dashboard', label: 'Dashboard',    icon: '📊' },
    { path: '/leads',     label: 'Leads',         icon: '👥' },
    { path: '/followups', label: 'Follow-ups',    icon: '📅' },
    { path: '/fees',      label: 'Student Fees',  icon: '💰' },
    { path: '/import',    label: 'Import/Export', icon: '📁' },
    { path: '/users',     label: 'Users',         icon: '👤', roles: ['admin'] },
    { path: '/settings',  label: 'Settings',      icon: '⚙️' },
];

export default function Sidebar({ collapsed, onToggle }) {
    const { user, logout } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    const visibleLinks = NAV.filter(n => !n.roles || n.roles.includes(user?.role));


    return (
        <aside className={`sidebar${collapsed ? ' collapsed' : ''}`}>
            <div className="sidebar-header">
                {!collapsed && (
                    <div className="sidebar-logo">
                        <span className="logo-icon">🎓</span>
                        LeadPro CRM
                    </div>
                )}
                <button className="sidebar-toggle" onClick={onToggle} title="Toggle sidebar">
                    {collapsed ? '→' : '←'}
                </button>
            </div>

            <nav className="sidebar-nav">
                {!collapsed && <div className="sidebar-section-title">Navigation</div>}
                {visibleLinks.map(({ path, label, icon }) => (
                    <Link
                        key={path}
                        to={path}
                        className={`sidebar-link${location.pathname.startsWith(path) ? ' active' : ''}`}
                        title={collapsed ? label : undefined}
                    >
                        <span className="sidebar-icon">{icon}</span>
                        {!collapsed && <span className="sidebar-label">{label}</span>}
                    </Link>
                ))}
            </nav>

            <div className="sidebar-footer">
                <div className="sidebar-user">
                    <div className="user-avatar-sm">{user?.name?.[0]?.toUpperCase()}</div>
                    {!collapsed && (
                        <div className="user-info">
                            <span className="user-name">{user?.name}</span>
                            <span className="user-role">{user?.role}</span>
                        </div>
                    )}
                </div>
                <button className="logout-btn" onClick={() => { logout(); navigate('/login'); }}>
                    <span>🚪</span>
                    {!collapsed && <span>Logout</span>}
                </button>
            </div>
        </aside>
    );
}
